<template>
  <div class="ts-h-screen ts-overflow-hidden">
    <ts-card-wrapper>
      <div class="row d-flex justify-content-between">
        <div class="btn-group btn-group-justified">
          <a
            class="btn btn-default"
            :class="{ 'btn-info': transfered }"
            :disabled="loading"
            @click.prevent="transfere"
          >
            {{ $t('stockTransfer.transfered') }}
          </a>
          <a
            class="btn btn-default"
            :class="{ 'btn-info': received }"
            :disabled="loading"
            @click.prevent="recieve"
          >
            {{ $t('stockTransfer.received') }}
          </a>
        </div>
        <div class="ts-w-64">
          <ts-input
            v-model="search"
            :placeholder="$t('search')"
            v-tooltip="$t('stockTransfer.search')"
            class="mr-2"
          />
        </div>
      </div>
    </ts-card-wrapper>
    <ts-table
      :columns="columns"
      :records="resources"
      :loading="loading"
      :expandable="true"
    >
      <template v-slot="{ record }">
        <td>{{ record.transfer_no }}</td>
        <td>{{ record.transfer_date }}</td>
        <td>{{ record.from_branch.branch_name_en }}</td>
        <td>{{ record.to_branch.branch_name_en }}</td>
        <td>
          {{
            record.from_location ? record.from_location.location_name_en : ''
          }}
        </td>
        <td>
          {{ record.to_location ? record.to_location.location_name_en : '' }}
        </td>
        <td class="ts-whitespace-no-wrap">
          {{
            record.transferred_by
              ? record.transferred_by.employee
                ? record.transferred_by.employee.employee_name_en
                : ''
              : ''
          }}
        </td>
        <td class="ts-whitespace-no-wrap ts-text-center">
          {{ record.transfer_date }}
        </td>
        <td class="ts-whitespace-no-wrap">
          {{
            record.received_by
              ? record.received_by.employee
                ? record.received_by.employee.employee_name_en
                : ''
              : ''
          }}
        </td>
        <td class="ts-whitespace-no-wrap ts-text-center">
          {{ record.received_date }}
        </td>
        <td class="text-center ts-whitespace-no-wrap">
          <a
            href="#"
            v-tooltip="$t('pdf')"
            class="mr-2 ml-2 text-red"
            @click.prevent="print(record)"
          >
            <i class="fas fa-file-pdf"></i>
          </a>
          <a
            href="#"
            v-tooltip="$t('excel')"
            class="mr-2 text-green ts-w"
            @click.prevent="exportExcel(record)"
            :disabled="record._deleting"
          >
            <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
            <i class="fas fa-file-excel" v-else></i>
          </a>
          <a
            href="#"
            v-tooltip="$t('view')"
            class="text-info"
            @click.prevent="view(record)"
          >
            <i class="fas fa-eye"></i>
          </a>
        </td>
      </template>
      <div slot="expand" slot-scope="prop">
        <table class="ts-w-11/12 ts-mx-auto detail">
          <thead>
            <tr>
              <th>{{ $t('stockTransfer.barcode') }}</th>
              <th>{{ $t('stockTransfer.group') }}</th>
              <th>{{ $t('stockTransfer.product') }}</th>
              <th class="text-center">{{ $t('stockTransfer.uom') }}</th>
              <th class="text-center">
                {{ $t('stockTransfer.qty') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(detail, index) in prop.record.stock_transfer_details"
              :key="index"
            >
              <td class="ts-p-1">
                {{ detail.product ? detail.product.barcode : '' }}
              </td>
              <td class="ts-p-1">
                {{ detail.product ? detail.product.pro_group_name_en : '' }}
              </td>
              <td class="ts-p-1">
                {{ detail.product ? detail.product.product_name_en : '' }}
              </td>
              <td class="ts-p-1 text-center">
                {{
                  detail.unit_of_measure
                    ? detail.unit_of_measure.uom_name_en
                    : ''
                }}
              </td>
              <td class="ts-p-1 text-center">{{ detail.quantity }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ts-table>
    <div
      class="ts-absolute ts-bottom-0 row d-flex ts-w-full justify-content-end"
    >
      <div class="p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </div>
    <a-modal
      :title="$t('pdf')"
      width="50%"
      v-model="show_pdf"
      :footer="null"
      :zIndex="1021"
    >
      <ts-preview-pdf v-model="waiting" :src="src" />
    </a-modal>
    <a-modal
      :title="$t('stockTransfer.transferBySerial')"
      width="50%"
      v-model="show_tranfer"
      :footer="null"
      :zIndex="1022"
    >
      <ShowTranfer />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as FileDownload from 'downloadjs'
import { debounce, trim } from 'lodash'
import ShowTranfer from './ComponentTranfer/ShowTranfer.vue'

export default {
  name: 'PendingWriteOffAndTransfer',
  components: {
    ShowTranfer
  },
  data () {
    return {
      loading: false,
      waiting: false,
      show_pdf: false,
      show_tranfer: false,
      src: '',
      transfered: 'active',
      received: ''
    }
  },
  created () {
    if (this.transfer_type == 'transfered') {
      this.transfer_type = 'transfered'
      this.transfered = 'active'
      this.received = ''
    }
    if (this.transfer_type == 'received') {
      this.transfer_type = 'received'
      this.received = 'active'
      this.transfered = ''
    }
  },
  computed: {
    ...mapState('pendingConfirmation/pendingConfirmation', [
      'resources',
      'pagination'
    ]),
    search: {
      get () {
        return this.$store.state.pendingConfirmation.pendingConfirmation.search
      },
      set (newValue) {
        this.$store.commit(
          'pendingConfirmation/pendingConfirmation/SET_SEARCH',
          newValue
        )
        this.$store.commit(
          'pendingConfirmation/pendingConfirmation/RESET_CURRENT_PAGE'
        )
      }
    },
    transfer_type: {
      get () {
        return this.$store.state.pendingConfirmation.pendingConfirmation
          .transfer_type
      },
      set (val) {
        this.$store.commit(
          'pendingConfirmation/pendingConfirmation/SET_TRANSFER_TYPE',
          val
        )
      }
    },
    columns () {
      return [
        { name: this.$t('pendingConfirmation.transferNo') },
        { name: this.$t('pendingConfirmation.transferDate') },
        { name: this.$t('pendingConfirmation.fromBranch') },
        { name: this.$t('pendingConfirmation.ToBranch') },
        { name: this.$t('pendingConfirmation.fromWarehouse') },
        { name: this.$t('pendingConfirmation.ToWarehouse') },
        { name: this.$t('pendingConfirmation.transfered_by') },
        {
          name: this.$t('pendingConfirmation.transfer_date'),
          style: 'text-align:center;'
        },
        { name: this.$t('pendingConfirmation.received_by') },
        {
          name: this.$t('pendingConfirmation.received_date'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:1px;white-space: nowrap;'
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'pendingConfirmation/pendingConfirmation/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    transfere () {
      this.transfer_type = 'transfered'
      this.transfered = 'active'
      this.received = ''
      this.fetchData()
    },
    recieve () {
      this.transfer_type = 'received'
      this.received = 'active'
      this.transfered = ''
      this.fetchData()
    },
    view (data) {
      this.$store.commit(
        'pendingConfirmation/pendingConfirmation/SET_EDIT_DATA',
        data
      )
      this.show_tranfer = true
    },
    print (record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('pendingConfirmation/pendingConfirmation/printPdf', {
          stock_transfer_id: record.stock_transfer_id,
          report_template: 'transfer-by-serial'
        })
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel (record) {
      record._deleting = true
      this.$store
        .dispatch('pendingConfirmation/pendingConfirmation/exportExcel', {
          stock_transfer_id: record.stock_transfer_id
        })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          record._deleting = false
        })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('pendingConfirmation/pendingConfirmation/RESET_STATE')
    next()
  }
}
</script>
